export default __webpack_public_path__ + "static/media/miguel-lopes-30.38269d0e.jpg";